export const commissionMonthlyStatementTableHeadingsData = [
  "Transaction Date",
  "Transaction Type",
  "Policy Details",
  "Customer Details",
  "Commission Earned",
];
export const comissionMonthlyStatementsData = [
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "HO34567891",
    commissionCustomerDetails: "Karen Garcia",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO34567891",
    commissionCustomerDetails: "Karen Garcia",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "HO44567891",
    commissionCustomerDetails: "Susan Anderson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/25/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO44567891",
    commissionCustomerDetails: "Susan Anderson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "HO45678903",
    commissionCustomerDetails: "Steven Martinez",
    comissionMonthlyEarned: "-11.25",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "HO50345679",
    commissionCustomerDetails: "William Davis",
    comissionMonthlyEarned: "-7.5",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "HO56789012",
    commissionCustomerDetails: "Lisa Robinson",
    comissionMonthlyEarned: "-15",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO63789012",
    commissionCustomerDetails: "Michael Williams",
    comissionMonthlyEarned: "18.75",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "HO66789012",
    commissionCustomerDetails: "Jessica Thomas",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/6/2024",
    commissionTransactionType: "Renewal",
    commissionPolicyDetails: "HO66789012",
    commissionCustomerDetails: "Jessica Thomas",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO67890126",
    commissionCustomerDetails: "Daniel Harris",
    comissionMonthlyEarned: "18.75",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "HO67901235",
    commissionCustomerDetails: "Mark Clark",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/25/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO67901235",
    commissionCustomerDetails: "Mark Clark",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/30/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO67901236",
    commissionCustomerDetails: "Mark Clark",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "HO67901237",
    commissionCustomerDetails: "Mark Clark",
    comissionMonthlyEarned: "-11.25",
  },
  {
    commissionDate: "10/20/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO82345679",
    commissionCustomerDetails: "John Smith",
    comissionMonthlyEarned: "22.5",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO82345680",
    commissionCustomerDetails: "Kevin Young",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO82345686",
    commissionCustomerDetails: "Emily Clark",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/14/2024",
    commissionTransactionType: "New Business",
    commissionPolicyDetails: "HO82345697",
    commissionCustomerDetails: "Steven Turner",
    comissionMonthlyEarned: "142.5",
  },
  {
    commissionDate: "10/30/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "HO82345716",
    commissionCustomerDetails: "Nicole Morgan",
    comissionMonthlyEarned: "-15",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "New Business",
    commissionPolicyDetails: "HO82345722",
    commissionCustomerDetails: "Joshua Bailey",
    comissionMonthlyEarned: "142.5",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO83901234",
    commissionCustomerDetails: "Robert Jones",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "HO83901237",
    commissionCustomerDetails: "Robert Jones",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/20/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "HO83901237",
    commissionCustomerDetails: "Robert Jones",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO90123457",
    commissionCustomerDetails: "Michelle Walker",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO90123458",
    commissionCustomerDetails: "Michelle Walker",
    comissionMonthlyEarned: "22.5",
  },
  {
    commissionDate: "10/30/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO91456790",
    commissionCustomerDetails: "Mary Johnson",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/25/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO91456791",
    commissionCustomerDetails: "Mary Johnson",
    comissionMonthlyEarned: "11.25",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "HO91567890",
    commissionCustomerDetails: "Elizabeth Garcia",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/25/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA12789012",
    commissionCustomerDetails: "Barbara Wilson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA23456789",
    commissionCustomerDetails: "Paul Thompson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/25/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA23456789",
    commissionCustomerDetails: "Paul Thompson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "PA34567890",
    commissionCustomerDetails: "Karen Garcia",
    comissionMonthlyEarned: "37.5",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "PA50345680",
    commissionCustomerDetails: "William Davis",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "PA58901234",
    commissionCustomerDetails: "Sarah White",
    comissionMonthlyEarned: "15",
  },
  {
    commissionDate: "10/20/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA63789013",
    commissionCustomerDetails: "Michael Williams",
    comissionMonthlyEarned: "-15",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA67890123",
    commissionCustomerDetails: "Daniel Harris",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/20/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA67890123",
    commissionCustomerDetails: "Daniel Harris",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA69876544",
    commissionCustomerDetails: "Linda Miller",
    comissionMonthlyEarned: "-7.5",
  },
  {
    commissionDate: "10/20/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA75234567",
    commissionCustomerDetails: "Jennifer Brown",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/30/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA75234567",
    commissionCustomerDetails: "Jennifer Brown",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA76234567",
    commissionCustomerDetails: "Christopher Jackson",
    comissionMonthlyEarned: "-22.5",
  },
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "PA77890123",
    commissionCustomerDetails: "Thomas Hernandez",
    comissionMonthlyEarned: "30",
  },
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA82345678",
    commissionCustomerDetails: "John Smith",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA82345678",
    commissionCustomerDetails: "John Smith",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA82345680",
    commissionCustomerDetails: "Kevin Young",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA82345684",
    commissionCustomerDetails: "Brian Lewis",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "PA82345686",
    commissionCustomerDetails: "Emily Clark",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA82345690",
    commissionCustomerDetails: "Stephanie Walker",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "Endorsement - Increase",
    commissionPolicyDetails: "PA82345694",
    commissionCustomerDetails: "Michelle Hall",
    comissionMonthlyEarned: "9",
  },
  {
    commissionDate: "10/14/2024",
    commissionTransactionType: "New Business",
    commissionPolicyDetails: "PA82345696",
    commissionCustomerDetails: "Steven Turner",
    comissionMonthlyEarned: "195",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA82345708",
    commissionCustomerDetails: "Nicholas Rogers",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/10/2024",
    commissionTransactionType: "New Business",
    commissionPolicyDetails: "PA82345721",
    commissionCustomerDetails: "Joshua Bailey",
    comissionMonthlyEarned: "165",
  },
  {
    commissionDate: "10/1/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA83901236",
    commissionCustomerDetails: "Robert Jones",
    comissionMonthlyEarned: "-15",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "PA89123456",
    commissionCustomerDetails: "Donald Lee",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA89765432",
    commissionCustomerDetails: "Patricia Moore",
    comissionMonthlyEarned: "-22.5",
  },
  {
    commissionDate: "10/30/2024",
    commissionTransactionType: "Endorsement - Decrease",
    commissionPolicyDetails: "PA91567891",
    commissionCustomerDetails: "Elizabeth Garcia",
    comissionMonthlyEarned: "-30",
  },
  {
    commissionDate: "10/5/2024",
    commissionTransactionType: "Cancellation",
    commissionPolicyDetails: "UM82345689",
    commissionCustomerDetails: "Anthony Robinson",
    comissionMonthlyEarned: "0",
  },
  {
    commissionDate: "10/15/2024",
    commissionTransactionType: "Reinstatement",
    commissionPolicyDetails: "UM82345689",
    commissionCustomerDetails: "Anthony Robinson",
    comissionMonthlyEarned: "0",
  },
];
